import { Form, Input, Select, TimePicker, Typography } from "antd";
import { LABEL_ALIGN, LINEAS_TIPOS, RULE_REQUIRED } from "constants";
import dayjs from "dayjs";
import useGetLineasTipos from "hooks/useGetLineasTipos";
import { useEffect, useState } from "react";
import { formatHour, normalizarTexto } from "utils";
import useGetLinea from "./useGetLinea";

const Formulario = ({ selectedLineaId, form, onFinish }) => {
  const { linea } = useGetLinea(selectedLineaId, 'editar');
  const { lineasTiposOptions } = useGetLineasTipos();
  const [selectedDiasKeys, setSelectedDiasKeys] = useState([]);
  const lineaTipoId = Form.useWatch("lineas_tipos_id", form);
  const showDias = [LINEAS_TIPOS.DESPACHO, LINEAS_TIPOS.ENTREGA].includes(lineaTipoId);

  useEffect(() => {
    if (linea) {
      const dias = {};

      linea.linea_horarios?.forEach(({ dia, horario_salida, frecuencia }) => {
        if (!dias[dia]) {
          dias[dia] = {
            horario_salida: dayjs.utc(horario_salida),
            frecuencia: frecuencia,
          };
        }
      });

      const seleccionados = Object.keys(dias).map((d) => parseInt(d));
      setSelectedDiasKeys(seleccionados);

      form.setFieldsValue({
        linea: linea.linea,
        lineas_tipos_id: linea.lineas_tipos_id,
        dias,
      });
    }
  }, [linea]);

  const handleFinish = (values) => {
    const lineas_horarios = Object.entries(values.dias || {})
      .filter(([diaKey]) => selectedDiasKeys.includes(parseInt(diaKey)))
      .map(([diaKey, data]) => {
        const dia = parseInt(diaKey);
        const { horario_salida, frecuencia } = data;

        return {
          dia,
          horario_salida: formatHour(horario_salida),
          frecuencia,
        };
      });

    // if (showDias && lineas_horarios.length === 0) {
    //   return message.info("Debe asignar al menos un día");
    // }

    const body = {
      linea: values.linea,
      lineas_tipos_id: values.lineas_tipos_id,
      lineas_horarios,
    };

    onFinish(body);
  };

  const columns = [
    {
      title: 'Día',
      dataIndex: 'label',
      width: 80,
      render: (_, dia) => {
        const visible = selectedDiasKeys?.includes(dia.dia);
        return (
          <Typography.Text disabled={!visible}>
            {dia.label}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Hora de salida',
      align: 'center',
      width: 110,
      render: (_, dia) => {
        const visible = selectedDiasKeys?.includes(dia.dia);
        return (
          <Form.Item
            name={['dias', dia.dia, 'horario_salida']}
            style={{ marginBottom: 0 }}
            preserve={false}
            rules={visible ? [{ required: true, message: '' }] : []}
          >
            {visible && (
              <TimePicker
                needConfirm={false}
                format="HH:mm"
                placeholder="Hora"
                style={{ width: 90 }}
              />
            )}
          </Form.Item>
        );
      },
    },
    // {
    //   title: 'Frecuencia',
    //   align: 'center',
    //   width: 110,
    //   render: (_, dia) => {
    //     const visible = selectedDiasKeys?.includes(dia.dia);
    //     return (
    //       <Form.Item
    //         name={['dias', dia.dia, 'frecuencia']}
    //         style={{ marginBottom: 0 }}
    //         preserve={false}
    //         rules={visible ? [{ required: true, message: '' }] : []}
    //       >
    //         {visible && (
    //           <Select
    //             options={[
    //               { value: 7, label: 'Semanal' },
    //               { value: 15, label: 'Quincenal' },
    //             ]}
    //             style={{ width: 130 }}
    //           />
    //         )}
    //       </Form.Item>
    //     );
    //   },
    // },
  ];

  const onSelectChange = (newSelectedDias) => {
    setSelectedDiasKeys(newSelectedDias);
  };

  const rowSelection = {
    selectedRowKeys: selectedDiasKeys,
    hideSelectAll: true,
    onChange: onSelectChange,
  };

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      labelAlign={LABEL_ALIGN}
      autoComplete="off"
      labelCol={{ span: 3 }}
    >
      <Form.Item
        label="Línea"
        name="linea"
        rules={[RULE_REQUIRED]}
      >
        <Input
          onInput={(e) => normalizarTexto(e, true, ["-"])}
          maxLength={100}
        />
      </Form.Item>

      <Form.Item
        label="Tipo"
        name="lineas_tipos_id"
        rules={[RULE_REQUIRED]}
      >
        <Select
          options={lineasTiposOptions}
          placeholder="Seleccionar"
          style={{ width: 150 }}
        />
      </Form.Item>

      {/* {showDias && ( */}
      {/* <Table
          rowKey="dia"
          size="small"
          columns={columns}
          dataSource={dias}
          pagination={false}
          rowSelection={rowSelection}
          onRow={record => ({
            onDoubleClick: () => {
              if (!selectedDiasKeys.includes(record.dia)) {
                const nuevosDias = [...selectedDiasKeys, record.dia];
                setSelectedDiasKeys(nuevosDias);
              }
            }
          })}
        /> */}
      {/* )} */}
    </Form>
  );
};

export default Formulario;
